import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {  EmployerContact } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-employer-verification',
  templateUrl: 'pap-employer-verification.component.html',
  styleUrls: ['./pap-employer-verification.component.less', '../../../shared/common.less'],
})

export class PapEmployerVerificationComponent implements OnInit {
  @Input() employer: EmployerContact;
  @Input() isExpanded: boolean = false;
  @Output() employerChange = new EventEmitter<EmployerContact>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  isValidated: boolean = false;

  constructor(
    private router: Router,
  ) {}
  
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }
  
  onEmployerChange() {
    this.employerChange.emit(this.employer);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }
  
  ngOnInit(): void {
  }
}
